export enum SystemFilter {
  LATEST = 'system:latest',
  POPULAR = 'system:popular',
  RECOMMENDED = 'system:recommended',
  ENGAGING = 'system:engaging',
}

export enum SectionPopularityCategory {
  NONE,
  POPULAR,
  THE_MOST_POPULAR,
}

export enum SectionTrendlineDirection {
  ASC,
  DESC,
}

export interface SectionPopularity {
  value: number
  category: SectionPopularityCategory
}

export interface SectionEngagement {
  data: number[]
  direction: SectionTrendlineDirection
  trendline: number
}

export interface SectionExtra {
  id?: string
  popularity: SectionPopularity
  engagement: SectionEngagement
  views: number
}
